<template>
    <div class="index-form">
        <Container width="landing">
            <div class="index-form__block">
                <div class="index-form__background">
                    <picture>
                        <source media="(max-width: 767px)" srcset="/images/index-page/form/form-bg-mobile.png" />
                        <source media="(max-width: 1024px)" srcset="/images/index-page/form/form-bg-tablet.png" />
                        <WBImage src="/images/index-page/form/form-bg-desktop.png" alt="" />
                    </picture>
                </div>
                <div class="index-form__content">
                    <div class="index-form__title">
                        Оставьте заявку
                    </div>

                    <div class="index-form__description">
                        Оставьте заявку и мы свяжемся с вами, ответим на интересующие вас вопросы и поможем с выбором
                        подходящего тарифа!
                    </div>
                </div>
                <div class="index-form__form-block">
                    <div class="index-form__wb">
                        <WBImage src="/images/index-page/form/wb.png" alt="" />
                    </div>
                    <form @submit.prevent="handleSubmit">
                        <WBInput v-model="form.name"
                                 class="index-form__input"
                                 type="text"
                                 inputmode="text"
                                 placeholder="Ваше имя"
                                 label="Имя"
                        />
                        <WBInput v-model="form.phone"
                                 class="index-form__input"
                                 name="phone"
                                 type="phone"
                                 mask="phone"
                                 inputmode="phone"
                                 placeholder="+7 (___) ___-__-__"
                                 label="Телефон"
                        />

                        <UiButton class="index-form__button" type="submit">
                            Оставить заявку
                        </UiButton>
                    </form>
                </div>
            </div>
        </Container>
    </div>
</template>

<script setup lang="ts">
    import Container from '~/src/shared/components/common/Container/Container.vue'
    import WBInput from '~/src/shared/components/ui/input/WBInput/WBInput.vue'

    const form = reactive({
        name: '',
        phone: '',
    })

    const handleSubmit = () => {
        //
    }
</script>

<style scoped lang="scss">
    .index-form {
        padding: 40px 0;

        &__block {
            position: relative;
            overflow: hidden;
            display: flex;
            height: 308px;
            padding: 8px;
            border-radius: 32px;
            background: linear-gradient(277.99deg, #205FF2 37.73%, #222CAD 112.68%);

            @include respond-to-custom(1023px) {
                flex-flow: column;
                height: 572px;
            }
        }

        &__background {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            width: 100%;
            height: 100%;
            pointer-events: none;

            img {
                @include respond-to-custom(1023px) {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    object-position: center;
                }
            }
        }

        &__content {
            position: relative;
            z-index: 2;
            max-width: 500px;
            padding: 40px;
            color: var(--white);

            @include respond-to-custom(1023px) {
                max-width: 100%;
                padding: 52px 40px 40px;
            }

            @include respond-to(mobile) {
                padding: 40px 24px;
            }
        }

        &__title {
            @include mulish32b;

            @include respond-to(mobile) {
                @include mulish24b;
            }
        }

        &__description {
            @include manrope17r;

            margin-top: 12px;

            @include respond-to(mobile) {
                @include manrope16r;

                margin-top: 16px;
            }
        }

        &__form-block {
            position: relative;
            z-index: 2;
            width: 100%;
            max-width: 621px;
            margin-left: auto;
            padding: 32px 40px;
            border-radius: 24px;
            background-color: var(--white);

            @include respond-to-custom(1023px) {
                max-width: 100%;
                margin-top: auto;
                margin-left: 0;
            }

            @include respond-to(mobile) {
                padding: 32px 24px;
            }
        }

        form {
            display: flex;
            align-items: flex-end;
            flex-flow: column;
            height: 100%;
        }

        &__input {
            width: 100%;

            &:not(:first-child) {
                margin-top: 24px;
            }
        }

        &__button {
            margin-top: 28px;
        }

        &__wb {
            position: absolute;
            right: 90%;
            bottom: -12px;

            @include respond-to-custom(1023px) {
                display: none;
            }
        }
    }
</style>
